import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

import { updateDocument } from '../store/slices/documentsSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch, sortedDropdownItemLabels } from '../utils/utils';

import KSelect from './KSelect';
import CrmButton from './CrmButton';

import docPreviewFormStyle from '../assets/jss/crm/components/docPreviewFormStyle.jsx';

class DocPreviewForm extends Component {
  validFileExtensionsForImage = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
  documentJson = '';

  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
      documentIsImage: true,
      documentUrl: '',
      documentOptions: [],
      documentType: '',
    };
  }

  componentDidMount() {
    this.getDocumentInfo();
    this.computeOptionLists();
  }

  computeOptionLists() {
    const documentOptions = ['None', ...this.getDocumentOptions()];
    this.setState({ documentOptions });
  }

  getDocumentOptions() {
    return sortedDropdownItemLabels('Document Type');
  }

  setDocumentType = (type) => {
    this.setState({ documentType: type });
  };

  getDocumentInfo = () => {
    const { storedDocumentId: docId, document } = this.props;
    if (docId > 0) {
      const uri = `/api/document/${docId}`;
      const request = createStdRequest(uri);
      const actionOnGoodResponse = (json) => {
        this.documentJson = json;
        this.setStateFromUrl();
      };
      apiFetch(null, request, actionOnGoodResponse);
    } else {
      this.documentJson = {
        storedDocumentId: docId,
        inquiryId: document.inquiryId,
        personId: document.personId,
        publicName: document.publicName,
        typeTag: document.typeTag,
        url: window.URL.createObjectURL(document.data),
      };
      this.setState({ documentIsImage: true, documentUrl: this.documentJson.url });
    }
  };

  doActualDownload = () => {
    const { storedDocumentId, document } = this.props;
    const { publicName } = this.documentJson;
    if (storedDocumentId > 0) {
      const uri = `/api/document/${storedDocumentId}/content`;
      fetch(uri).then((response) => {
        response.blob().then((blob) => {
          this.downloadDocument(publicName, blob);
        });
      });
    } else {
      this.downloadDocument(publicName, document.data);
    }
  };

  downloadDocument(name, data) {
    const url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
  }

  setStateFromUrl = () => {
    const { url } = this.documentJson;
    if (this.determineIsDocumentImage(url)) {
      this.setState({ documentIsImage: true, documentUrl: url });
    } else {
      const googleDocumentExtension = 'https://docs.google.com/viewer?embedded=true&url=';
      this.setState({ documentIsImage: false, documentUrl: googleDocumentExtension + url });
    }
  };

  determineIsDocumentImage = (url) => {
    for (let i = 0; i < this.validFileExtensionsForImage.length; i++) {
      if (url.endsWith(this.validFileExtensionsForImage[i])) {
        return true;
      }
    }
    return false;
  };

  acceptForm() {
    this.updateDocumentRequest(this.documentJson);
  }

  updateDocumentRequest(document) {
    if (this.state.documentType !== document.typeTag) {
      if (document.personId > 0) {
        const uri = `/api/document/${document.storedDocumentId}`;
        const apiStruct = {
          typeTag: this.state.documentType === 'None' ? null : this.state.documentType,
          description: this.documentJson.description.trim(),
        };
        const request = createStdRequest(uri, 'put', apiStruct);
        const actionOnGoodResponse = (json) => {
          this.props.updateDocument(json);
          this.cancelModal();
        };
        apiFetch(this, request, actionOnGoodResponse);
      } else {
        this.props.document.typeTag = this.state.documentType;
        if (document.inquiryId > 0) {
          this.props.parent.setState({ isDocModified: true });
        }
      }
      this.cancelModal();
    } else {
      this.cancelModal();
    }
  }

  cancelModal = () => {
    this.props.closeModalFunc();
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const { classes } = this.props;
    const { documentIsImage, documentUrl, documentOptions, documentType } = this.state;

    return (
      <Grid container spacing={2}>
        {documentOptions.length > 0 && (
          <Grid item xs={8}>
            <KSelect
              fullWidth
              label="Document Type (optional)"
              liveOptions={documentOptions}
              value={documentType || this.documentJson.typeTag}
              onChange={(event) => this.setDocumentType(event.target.value)}
            />
          </Grid>
        )}
        {this.documentJson.storedDocumentId > 0 && (
          <Grid item className={classes.downloadButton} xs={3}>
            <div>
              <CrmButton filled size="small" onClick={this.doActualDownload}>
                Download
              </CrmButton>
            </div>
          </Grid>
        )}

        <Grid item xs={12}>
          {documentIsImage ? (
            <img className={classes.previewSize} src={documentUrl} alt="Preview" />
          ) : (
            <iframe className={classes.previewSize} src={documentUrl} title="Preview" />
          )}
        </Grid>

        <Grid item xs={12}>
          <div className={classes.buttonDiv}>
            <CrmButton outlined onClick={() => this.cancelModal()}>
              Cancel
            </CrmButton>
            <CrmButton filled onClick={() => this.acceptForm()}>
              Save
            </CrmButton>
          </div>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({});
const actionProducers = { updateDocument, setApiResponseInfo };
export default connect(mapStateToProps, actionProducers)(withStyles(docPreviewFormStyle)(DocPreviewForm));
